module.exports = __webpack_public_path__ + "img/david-jump-longines.86d6251d.jpg";